import request from "@/utils/request";
import requestNo from "@/utils/requestNo";

// 获取验证码
export function getcaptcha(data) {
    return request({
        url: "/api/captcha/getImg",
        method: "get",
        params: data,
    });
}
// 获取手机验证码
export function getSms(data) {
    return request({
        url: "/api/xuser/getSms",
        method: "post",
        data: data,
    });
}
// 注册
export function register(data) {
    return request({
        url: "/api/xuser/register",
        method: "post",
        data: data,
    });
}
// 找回密码

export function retrievePassword(data) {
    return request({
        url: "/api/xuser/retrievePassword",
        method: "post",
        data: data,
    });
}
// 修改密码
export function changePwd(data) {
    return request({
        url: "/api/xuser/changePwd",
        method: "post",
        data: data,
    });
}

// 登录
export function login(data) {
    return request({
        url: "/api/user/login",
        method: "post",
        data: data,
    });
}
// 获取用户信息
export function getUserInfo(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/xuser/info?custom_id=${custom_id}`,
        method: "post",
        params: data,
    });
}

// 协议接口   sys_userr_privacy  诚信承诺书    sys_user_agree用户协议   platform_rule帮助文档 the_cancellation_prompt咨询电话
export function agreement(key) {
    return request({
        url: `/api/agreement/${key}`,
        method: "get",
    });
}

// 获取网站入口列表
export function getlist(data) {
    return request({
        url: "/api/platform/list",
        method: "get",
        params: data,
    });
}

// 获取总平台公用
export function system1(data) {
    return request({
        url: "/api/platform/system",
        method: "get",
        params: data,
    });
}
export function system2(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/system?custom_id=${custom_id}`,
        method: "get",
        params: data,
    });
}
// 获取报名表单
export function getFormTable(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/getFormTable?custom_id=${custom_id}`,
        method: "get",
        params: data,
    });
}

// 获取首页数据
export function indexData(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/indexBulletin?custom_id=${custom_id}`,
        method: "get",
        params: data,
    });
}

// 招聘公告列表
export function bulletinList(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/${custom_id}/bulletinList`,
        method: "get",
        params: data,
    });
}
// 招聘公告详情
export function bulletinInfo(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        // url: `/api/sub/${custom_id}/bulletin/${id}`,
        url: `/api/sub/bulletin?id=${id}&custom_id=${custom_id}`,
        method: "get",
    });
}
// 报考指南列表
export function applyGuide(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/applyGuide?custom_id=${custom_id}`,
        method: "get",
        params: data,
    });
}
// 报考指南详情
export function applyGuideInfo(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        // url: `/api/sub/${custom_id}/applyGuide/${id}`,
        url: `/api/sub/applyGuideInfo?id=${id}&custom_id=${custom_id}`,
        method: "get",
    });
}
// 招聘计划名称
export function planConfig(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        // url: `/api/sub/${custom_id}/planConfig`,
        url: `/api/sub/planConfig?custom_id=${custom_id}`,
        method: "get",
        params: data,
    });
}

// 招聘计划列表
export function planList(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        // url: `/api/sub/${custom_id}/plan`,
        url: `/api/sub/plan?custom_id=${custom_id}`,
        method: "get",
        params: data,
    });
}

// 报名信息字段
export function signup(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/${custom_id}/signup/${id}`,
        method: "get",
    });
}
export function signUpReason(data) {
    return request({
        url: `/api/sub/signUpReason`,
        method: "post",
        data: data,
    });
}
// 仲裁或改报
export function arbitraOrsub(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/${custom_id}/arbitraOrsub`,
        method: "post",
        data: data,
    });
}
// 报名信息详情
export function signupDetail(id, ex_id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/signupDetail?custom_id=${custom_id}&ex_id=${ex_id}`,
        method: "get",
    });
}
// 编辑报名信息
export function updateUser(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/update_user?custom_id=${custom_id}`,
        method: "post",
        data: data,
    });
}
// 报名信息字段
export function signupCreate(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/${custom_id}/signupCreate`,
        method: "post",
        data: data,
    });
}

// 我的报名表 准考证
export function isignUpTicket() {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/${custom_id}/isignUpTicket`,
        method: "get",
    });
}
// 面试准考证
export function interviewExamCard(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/interviewExamCard?custom_id=${custom_id}`,
        method: "post",
        data: {
            id: id,
        }
    });
}
// 笔试准考证
export function writtenExamCard(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/writtenExamCard?custom_id=${custom_id}`,
        method: "post",
        data: {
            id: id,
        }
    });
}

// 打印准考证时间
export function printExamCard(data) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/print_card?custom_id=${custom_id}`,
        method: "post",
        data: data
    });
}

// 成绩列表
export function scoreList(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/scoreList?custom_id=${custom_id}`,
        method: "post",
        data: {
            id: id,
        }
    });
}
// 笔试成绩
export function penScore(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/penScore?custom_id=${custom_id}`,
        method: "post",
        data: {
            id: id,
        }
    });
}
// 面试成绩
export function interviewScores(id) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/interviewScores?custom_id=${custom_id}`,
        method: "post",
        data: {
            id: id,
        }
    });
}
// 获取协议
export function systemPrivacy() {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/privacy?custom_id=${custom_id}`,
        method: "get",
    });
}

// 报名支付获取支付二维码
export function pay(payId) {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/pay`,
        method: "post",
        data: {
            id: payId,
        },
    });
}
// 报名支付获取支付状态
export function getPlanIsPay(payId) {
    let custom_id = localStorage.getItem("custom_id");
    return requestNo({
        url: `/api/sub/getPlanIsPay`,
        method: "post",
        data: {
            id: payId,
        },
    });
}

export function signUpTicketId() {
    let custom_id = localStorage.getItem("custom_id");
    return request({
        url: `/api/sub/signUpTicketId?custom_id=${custom_id}`,
        method: "get",
    });
}

export function singUp(data) {
    let custom_id = localStorage.getItem("custom_id");
    data.custom_id = custom_id
    return request({
        url: `/api/sing_up/index`,
        method: "post",
        data: data,
    });
}
// 获取支付宝二维码
export function alipay(data) {
    return request({
        url: `/api/xuser/alipayInit`,
        method: "post",
        data: data,
    });
}
// 轮寻查询认证状态
export function status(data) {
    return request({
        url: `/api/xuser/queryCertifyStatus`,
        method: "post",
        data: data,
        silent: true,
    });
}